import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { WarehouseConsumableDto } from "@/core/features/warehouse-consumable/warehouse-consumable.dto";
import { CreateWarehouseConsumableDto } from "@/core/features/warehouse-consumable/create-warehouse-consumable.dto";
import { UpdateWarehouseConsumableDto } from "@/core/features/warehouse-consumable/update-warehouse-consumable.dto";
import { HttpRequest } from "@/core/common/http/http-request";
import { plainToInstance } from "class-transformer";
import { IRequest } from "@/interfaces/IRequest";

export class WarehousesConsumableResource extends ResourceBaseService<
  WarehouseConsumableDto,
  CreateWarehouseConsumableDto,
  UpdateWarehouseConsumableDto
> {
  protected EntityDto = WarehouseConsumableDto;
  protected CreateEntityDto = CreateWarehouseConsumableDto;
  protected UpdateEntityDto = UpdateWarehouseConsumableDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/warehouse-consumables");
  }

  async getStockByWarehouseConsumable(
    warehouseId: string,
    consumableId: string,
    options: { locationId?: string; onlyOpenLocations?: boolean } = {}
  ): Promise<WarehouseConsumableDto> {
    const queryParams = new URLSearchParams();
    if (options.locationId) {
      queryParams.set("locationId", options.locationId);
    }
    if (options.onlyOpenLocations) {
      queryParams.set("onlyOpenLocations", "1");
    }

    return this.apiHttpClient
      .request(
        HttpRequest.create({
          url: this.resourceUrl + "/warehouse/" + warehouseId + "/consumable/" + consumableId,
          method: "GET",
          auth: true,
          query: queryParams.toString(),
        })
      )
      .then((result) => plainToInstance(WarehouseConsumableDto, result));
  }

  async getNotEnoughStockInWarehouse(warehouseId: string): Promise<number> {
    return this.apiHttpClient
      .request(
        HttpRequest.create({
          url: this.resourceUrl + "/" + warehouseId + "/min-stock",
          method: "GET",
          auth: true,
        })
      )
      .then((result) => Number(result));
  }

  async exportExcel(request: IRequest): Promise<{ status: "queued"; jobId: string }> {
    return this.apiHttpClient.request<null, { status: "queued"; jobId: string }>(
      HttpRequest.create({
        url: this.resourceUrl + "/excel",
        method: "GET",
        auth: true,
        query: this.getQueryBuilder(request).query(),
      })
    );
  }

  async getTotalCost(request: IRequest): Promise<WarehouseConsumableDto> {
    return this.apiHttpClient
      .request(
        HttpRequest.create({
          url: this.resourceUrl + "/total-cost",
          method: "GET",
          auth: true,
          query: this.getQueryBuilder(request).query(),
        })
      )
      .then((result) => plainToInstance(WarehouseConsumableDto, result));
  }
}
